"use client";
import { cn } from "@/lib/utils";
import Lottie from "lottie-react";
import searchAnimation from "public/animation/search.json";
export const GoGlobal = () => {
  return (
    <div className="w-[full] flex flex-col justify-center items-center  pt-[91px] overflow-hidden ">
      <div className="w-[full] text-[#0F2B5B] text-center font-['Alibaba_PuHuiTi_3.0'] text-[3.125rem] font-bold  ">
        出海需求洞察
      </div>
      <div className="w-full text-[rgba(51,51,51,0.50)] font-['Alibaba_PuHuiTi_3.0'] text-[1.5rem] font-light  tracking-[4.4px] uppercase text-center">
        Insight into Overseas Expansion Needs
      </div>

      <div className="mt-[126px]">
        <div className="w-[867px] h-[385px] flex-shrink-0 aspect-[286/127]  relative ">
          <div className="w-[28.375rem] h-[28.375rem] flex-shrink-0 rounded-[50%] blur-[150px] bg-[rgba(188,225,255,0.40)]  absolute top-[-12rem] right-[-17rem] z-[10]"></div>
          <div className="w-[39.5625rem] h-[39.5625rem] flex-shrink-0 rounded-[50%] bg-[#EEF0FF] blur-[150px] absolute top-[7.4rem] left-[-23rem] z-[10]"></div>
          <Item
            content="“需要了解行业全貌，投资一个能稳定盈利的跨境电商项目”"
            className="w-[410px] left-[-210px] text-[1.375rem] text-[#2D4F7E]"
          />
          <Item
            content="“国内太卷了，已经卷不动了，被迫拓展海外市场"
            className="w-[323px] left-[310px] top-[-20px] text-[1.0625rem] text-[rgba(37, 61, 93, 0.90)]"
          />
          <Item
            content="“什么都不懂，担心试错有损失,不知道该怎么下手“"
            className="w-[323px] left-[783px] top-[-20px] text-[1rem] text-[#253D5D]"
          />

          <Item
            content="“出海流量贵、效率低，卡在瓶颈难增长“"
            className="w-[448px] left-[-260px] top-[198px] text-[1.625rem] text-[#061E3D]"
          />
          <Item
            content="“需要找寻新的销售渠道，建立自己的国际品牌拓宽海外市场”"
            className="w-[356px] left-[-58px] top-[367px] text-[#152F51] text-[1.1875rem]"
          />

          <Item
            content="“需要找寻新的销售渠道，建立自己的国际品牌拓宽海外市场”"
            className="w-[401px] right-[-300px] top-[190px] text-[#0A2D5D] text-[1.25rem]"
          />

          <Item
            content="“全球用户访问慢，数据安全与合规压力大”"
            className="w-[401px] right-[-150px] top-[350px] text-[#0A2D5D] text-[1.25rem]"
          />
          <Lottie
            animationData={searchAnimation}
            loop
            style={{
              width: "54.1875rem",
              height: "24.0625rem",
              zIndex: 5,
              transform: "scale(calc(1 / max(1, var(--page-scale, 1))))",
              transformOrigin: "top left",
              willChange: "transform",
            }}
            width={867}
            height={385}
          />
        </div>
      </div>
      <div className=" min-h-[198px] min-w-10"></div>
    </div>
  );
};

const Item = ({
  content,
  className,
}: {
  content: string;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "inline-flex p-[10px_40px] flex-col items-start gap-[10px] rounded-[70px] bg-gradient-to-r from-[#B8E1FF] to-[rgba(238,225,255,0.20)] shadow-[0_4px_10px_0_rgba(0,0,0,0.06)]",
        "absolute",
        "z-[10]",
        className,
        "hover:bg-gradient-to-r hover:from-[#0182FF] hover:to-[#0182FF] hover:text-[#ffffff]",
        "text-[#2D4F7E] font-['Alibaba_PuHuiTi_3.0'] text-[17px] font-normal leading-none"
      )}
    >
      <div>{content}</div>
    </div>
  );
};
